module.exports = __webpack_public_path__ + "img/mg-shopLibraryAddMaterial-example.5560357d.png";